import { ORGANIZATION_DATA, WEBSITE_DATA } from '~/components/constants';

export const constructStructuredData = (): string =>
  JSON.stringify([ORGANIZATION_DATA, WEBSITE_DATA]);
